import React, { useEffect, useState } from 'react'

export default function Banner(props) {
    
    return (
        <div className="banner-img-bg mx-md-5 text-light  py-4 ">
            {/* <img className=" img-fluid banner-img" src="img/banner/1.jpg" alt="" /> */}
            <div className="d-md-flex align-items-center justify-content-between text-center">
                    <div className="glow-div2 glassBg-box-timer text-center">
                        <h2 className="my-4">Play Game And Earn</h2>
                    </div>
            </div>

        </div>
    )
}
